import TableLayout from "../../../layout/main/TableLayout";
import { Column, Flex, Relative, Row } from "../../../../styles/CommonStyles";
import { formatNumber } from "../../../../core/utils/common";
import DateTime from "../../../common/utils/DateTime";
import useGetTableIndex from "../../../../core/hooks/layout/useGetTableIndex";
import { rewardsListAttributes } from "../../../../core/constants/headers";


const RewardsListTable = ({
    data
}) => {

    const { data: transactions } = data
    const { cs, headers } = rewardsListAttributes
    const { getTableIndex } = useGetTableIndex()



    return (
        <TableLayout
            headers={headers}
            cs={cs}
            data={data}
            hasWriteAccess={true}
        >
            {transactions?.data?.map((item, idx) => {

                return (
                    <Relative>

                        <Row cs={cs} index={idx} key={item._id}>
                            <Column>
                                {getTableIndex(idx)}
                            </Column>
                            <Column avatar>
                                <Flex width='42px'>
                                    {data?.record_id || "-"}
                                </Flex>
                            </Column>
                            <Column>
                                {formatNumber(item.amount)}
                            </Column>

                            <Column>
                                {data.currency}
                            </Column>

                            <Column center>
                                <DateTime dt={item.createdAt} />
                            </Column>
                        </Row>
                    </Relative>
                )
            })}
        </TableLayout>
    )
}



export default RewardsListTable
